import keywordCsv from './semrush/semrush-keyword-mapping.csv?raw';

const SITE_ORIGIN = 'https://www.joeyfamily.com';

type KeywordMap = Record<string, string[]>;

const parseCsvLine = (line: string): string[] => {
  const cells: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i += 1) {
    const char = line[i];

    if (char === '"') {
      if (inQuotes && line[i + 1] === '"') {
        current += '"';
        i += 1;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      cells.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  cells.push(current);
  return cells.map((cell) => cell.trim());
};

const parseCsv = (text: string): KeywordMap => {
  const lines = text.split(/\r?\n/).filter((line) => line.trim().length > 0);
  if (lines.length === 0) {
    return {};
  }

  const headers = parseCsvLine(lines[0]);
  const keywordIndex = headers.indexOf('Keyword');
  const suggestedIndex = headers.indexOf('Suggested Landing');
  const currentIndex = headers.indexOf('Current Landing');

  const map: KeywordMap = {};

  const normalizePath = (input: string | undefined | null): string | null => {
    if (!input) return null;
    try {
      const url = new URL(input, SITE_ORIGIN);
      const normalized = url.pathname.replace(/\/+$/, '') || '/';
      return normalized;
    } catch {
      return null;
    }
  };

  for (let i = 1; i < lines.length; i += 1) {
    const columns = parseCsvLine(lines[i]);
    const keyword = keywordIndex >= 0 ? columns[keywordIndex] : '';
    const landing =
      (suggestedIndex >= 0 ? columns[suggestedIndex] : '') ||
      (currentIndex >= 0 ? columns[currentIndex] : '');
    const path = normalizePath(landing);

    if (!keyword || !path) continue;

    if (!map[path]) {
      map[path] = [];
    }
    if (!map[path].includes(keyword)) {
      map[path].push(keyword);
    }
  }

  return map;
};

const KEYWORD_MAP = parseCsv(keywordCsv);

/**
 * Returns the list of keywords that should be applied to the provided path.
 * Matching is path-based (no query/hash) and trailing slashes are ignored.
 */
export const getKeywordsForPath = (path: string): string[] => {
  if (!path) return [];
  const normalized = (() => {
    try {
      const url = new URL(path, SITE_ORIGIN);
      return url.pathname.replace(/\/+$/, '') || '/';
    } catch {
      return path.replace(/\/+$/, '') || '/';
    }
  })();

  return KEYWORD_MAP[normalized]?.slice() ?? [];
};

export const keywordMap = KEYWORD_MAP;

